function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  ",
        "\n  ",
        "\n  transition: 0.2s linear color;\n  text-decoration: none;\n  cursor: pointer;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
import { withContext } from "../wr-context";
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var Link = styled(function(props) {
    var theme = props.theme, context = props.context, inactive = props.inactive, secondary = props.secondary, disabled = props.disabled, rest = _objectWithoutProperties(props, [
        "theme",
        "context",
        "inactive",
        "secondary",
        "disabled"
    ]);
    if (rest.to) {
        var onClick = rest.onClick, target = rest.target;
        // Copied from React Router Link
        // https://github.com/ReactTraining/react-router/blob/f466c8c4/packages/react-router-dom/modules/Link.js
        rest.onClick = function(event) {
            try {
                if (onClick) onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && event.button === 0 && (!target || target === "_self") && !isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                context.history.push(rest.to);
            }
        };
    }
    return /*#__PURE__*/ React.createElement("a", _extends({}, rest));
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.primary;
}, function(param) {
    var secondary = param.secondary, theme = param.theme;
    return secondary && "color: ".concat(theme.palette.secondary, ";");
}, function(param) {
    var inactive = param.inactive, theme = param.theme;
    return inactive && "color: ".concat(theme.palette.neutral, ";");
}, function(param) {
    var disabled = param.disabled;
    return disabled && "pointer-events: none;";
});
export default withContext(Link);
